import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import BILAwards from '../tables/BILAwards'
import MapView from '../maps/MapView'
import FundingByCategory from '../charts/FundingByCategory'
import FundingBySubcategory from '../charts/FundingBySubCategory'

import Skills_Transfer from '../tables/Skills_Transfer'
import OccupationsTable from '../tables/OccupactionsTable'

import CommuterMap from '../maps/CommuterMap'

const PrivateRoutes = () => {
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Navigate to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />
        <Route path='bli-awards' element={<BILAwards />} />
        <Route path='colorado_map' element={<MapView />} />
        <Route path='funding_by_category' element={<FundingByCategory />} />
        <Route path='funding_by_subacategory' element={<FundingBySubcategory />} />
        <Route path='skills_transfer' element={<Skills_Transfer />} />
        <Route path='occupations' element={<OccupationsTable />} />

        <Route path='commuter_map' element={<CommuterMap />} />

        {/* Lazy Modules
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--kt-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
